import { useAuth } from "@/hooks/useAuth";
import { MyClaimsDashboard } from "./MyClaimsDashboard";
import { AccountingReviewPage } from "./AccountingReviewPage";

/**
 * The single /commissions route is role-aware (Commission Module lockdown,
 * 2026-06):
 *   ADMIN          → Accounting Review Queue (the elevated reviewer surface)
 *   everyone else  → My Claims Dashboard (own claims only)
 *
 * All elevated commission surfaces — the review queue, All Claims, the Payment
 * Ledger, allocations / rates / pools, escalation, period lock, payouts, and
 * reports — are ADMIN-only. Non-admins (including executives and Accounting/B3)
 * see only their own My Claims, enforced both here and by the backend
 * permission grants + route guards.
 */
export function CommissionsPage() {
  const { user } = useAuth();
  const roles = user?.roleCodes ?? [];

  if (roles.includes("ADMIN")) {
    return <AccountingReviewPage />;
  }
  return <MyClaimsDashboard />;
}
